import React from 'react';

// TCC Components
import { App } from '../../App'
import { NoAccess } from '../../components/Alerts/NoAccess';
import { Surface } from '../../styles/Containers'
import { StyledH1, StyledP } from '../../styles/StyledHTML'

export const NoAccessPage = () => {

    return (
        <App title="No Access">
            <NoAccess />
        </App>
    );
}